// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"a8ac7e97","453":"e56c6eff","470":"1bcb717f","725":"e780717a","831":"7d02a773"}[chunkId] + ".chunk.js";
};